<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>{{ t('agent.agentInfo') }}</v-card-title>
          <v-card-subtitle>
            {{  t('agent.welcome') }}
          </v-card-subtitle>
          <v-card-text>
            <v-card-subtitle>
              {{ formatAddress(props.walletConnect.walletAddress) }}
            </v-card-subtitle>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>{{ t('agent.invitesLink') }}</v-card-title>
          <v-card-subtitle>
            <v-row>
              <v-col cols="10">
                <v-text-field v-model="invitesLink" readonly disabled></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn icon @click="copyInvitesLink">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="2">
        <v-card>
          <v-card-title>{{ t('agent.cumulativeSales') }}</v-card-title>
          <v-card-subtitle>{{ agentInfo.saleAmount }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" md="2">
        <v-card>
          <v-card-title>{{ t('agent.todaySales') }}</v-card-title>
          <v-card-subtitle>{{ todaySales }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-row>
            <v-col cols="8">
              <v-card-title>{{ t('agent.unReward') }} {{ agentInfo.unreward }}</v-card-title>
              <v-card-subtitle>
                  ${{ agentInfo.unreward }}
              </v-card-subtitle>
            </v-col>
            <v-col cols="4">
              <v-btn class="claim-button" @click="claimUnreward">
                {{ t('agent.claim') }}
              </v-btn>
            </v-col>
            </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="2">
        <v-card>
          <v-card-title>{{ t('agent.pushEarnings') }}</v-card-title>
          <v-card-subtitle>${{ directIncome }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" md="2">
        <v-card>
          <v-card-title>{{ t('agent.interPushEarnings') }}</v-card-title>
          <v-card-subtitle>${{ indirectIncome }}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-card class="mb-4">
          <v-card-title>{{ t('agent.agentAchievement') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-card class="summary-card">
                  <v-card-title>{{ t('agent.todayAchievement') }}</v-card-title>
                  <v-card-subtitle>${{ todayAchievement }}</v-card-subtitle>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card class="summary-card">
                  <v-card-title>{{ t("agent.totalAchievement") }}</v-card-title>
                  <v-card-subtitle>${{ totalAchievement }}</v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="mb-4">
          <v-card-title>{{ t('agent.earningsStatistics') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-card class="summary-card">
                  <v-card-title>{{ t('agent.todayEarnings') }}</v-card-title>
                  <v-card-subtitle>${{ todayEarnings }}</v-card-subtitle>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card class="summary-card">
                  <v-card-title>{{ t('agent.totalEarnings') }}</v-card-title>
                  <v-card-subtitle>${{ totalEarnings }}</v-card-subtitle>
                </v-card>
              </v-col>
            </v-row> 
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { fetchUserInvites, fetchAgentDashboard } from '@/api/apiService';
import { onMounted, ref,defineProps,getCurrentInstance, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
const props = defineProps({
  walletConnect: {
    type: Object,
    required: true
  }
});
const { proxy } = getCurrentInstance();
const { t } = useI18n();
const agentInfo = ref({
  agentFee: 0,
  childAgents: [],
  isBlack: false,
  isStore: false,
  reward: 0,
  saleAmount: 0,
  superior: "",
  unreward: 0,
});
const invitesLink = ref('');
const directIncome = ref(0);
const indirectIncome = ref(0);
const todaySales = ref(0);
const totalSales = ref(0);
const todayEarnings = ref(0);
const totalEarnings = ref(0);
const totalAchievement = ref(0);
const todayAchievement = ref(0);
onMounted(() => {
  // if(!localStorage.getItem('firstReloadState') || localStorage.getItem('firstReloadState') === 'false') {
  //   location.reload();
  //   localStorage.setItem('firstReloadState', true);
  // }
  props.walletConnect.setLoading(true);
  proxy.$eventBus.on('walletConnectInitialized', async () => {
    let decimal = await props.walletConnect.usdtContract.methods.decimals().call();
    decimal = Number(decimal);
    try {
      const agentInfos = await props.walletConnect.getAgentInfo(props.walletConnect.walletAddress);
      // console.log(agentInfos, "agentInfo");
      // console.log(props.walletConnect);
      agentInfo.value = {
        agentFee: parseFloat(agentInfos.agentFee),
        childAgents: agentInfos.childAgents,
        isBlack: agentInfos.isBlack,
        isStore: agentInfos.isStore,
        reward: Number(agentInfos.reward) /  10**decimal,
        saleAmount: Number(agentInfos.saleAmount),
        superior: agentInfos.superior,
        unreward: Number(agentInfos.unreward) / 10**decimal,
      };
      // console.log(agentInfo.value,  'agentInfo vvalue');
    } catch (error) {
      console.error(error);
    }
  });
  loadData();
});

const formatAddress = (address) => {
  return address.slice(0, 6) + '...' + address.slice(-4);
}
const claimUnreward = async () => {
  if(agentInfo.value.unreward > 0){
    try {
      props.walletConnect.setLoading(true);
      await props.walletConnect.gainUnReward();
      loadData();
    }catch(err) {
      props.walletConnect.setLoading(false);
      console.error(err);
    }
  } else {
    proxy.$toast.error(t('agent.noUnreward'));
  }
}

const copyInvitesLink = () => {
  navigator.clipboard.writeText(invitesLink.value);
  proxy.$toast.success(t('agent.copySuccess'));
};
const loadData = async () => {
  let decimal = await props.walletConnect.usdtContract.methods.decimals().call();
  decimal = Number(decimal);
  try {
    const agentInfos = await props.walletConnect.getAgentInfo(props.walletConnect.walletAddress);
    // console.log(agentInfos, "agentInfo loaddata");
    console.log(props.walletConnect);
    agentInfo.value = {
      agentFee: parseFloat(agentInfos.agentFee),
      childAgents: agentInfos.childAgents,
      isBlack: agentInfos.isBlack,
      isStore: agentInfos.isStore,
      reward: Number(agentInfos.reward) /  10**decimal,
      saleAmount: Number(agentInfos.saleAmount),
      superior: agentInfos.superior,
      unreward: Number(agentInfos.unreward) / 10**decimal,
    };
    props.walletConnect.setLoading(false);
    // console.log(agentInfo.value,  'agentInfo vvalue');
  } catch (error) {
    props.walletConnect.setLoading(false);
    console.error(error);
  }
  const invites = await fetchUserInvites();
  invitesLink.value = invites.data.data.invite_link;
  const agentDashboard = await fetchAgentDashboard();
  directIncome.value = agentDashboard.data.data.directIncome / 10**decimal;
  indirectIncome.value = agentDashboard.data.data.indirectIncome / 10**decimal;
  todaySales.value = agentDashboard.data.data.todaySales;
  totalSales.value = agentDashboard.data.data.totalSales;
  todayEarnings.value = agentDashboard.data.data.todayRewards / 10**decimal;
  totalEarnings.value = agentDashboard.data.data.totalRewards / 10**decimal;
  todayAchievement.value = agentDashboard.data.data.todayAchievement / 10**decimal;
  totalAchievement.value = agentDashboard.data.data.totalAchievement / 10**decimal;
  console.log(agentDashboard, "agentDashboard");
};
onUnmounted(() => {
  proxy.$eventBus.off('walletConnectInitialized');
});
</script>

<style scoped>
.summary-card {
  background-color: #f5f5f5;
  color: #333;
  text-align: center;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.v-btn {
  text-transform: none !important; /* Apply globally to all Vuetify buttons */
}
.claim-button {
  margin: 10px 10px 0 0;
  background-color: #007bff;
  color: white;
  border-radius: 5px;
  padding: 5px 10px;
}
.claim-button:hover {
  background-color: #0056b3;
}
</style>
